import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "page-layout__intro-description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", {
    slot: "scrollbar",
    class: _normalizeClass(["page-layout__intro-text", {'page-layout__intro-text--bottom': _ctx.placeTextBottom}])
  }, [
    _createVNode(_component_v_container, {
      class: _normalizeClass({'text-center': !_ctx.placeTextBottom})
    }, {
      default: _withCtx(() => [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        (_ctx.text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.text), 1))
          : _createCommentVNode("", true),
        (_ctx.buttonText)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 2,
              color: "primary",
              size: "large",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"])
  ], 2))
}